import { render } from "./RecycleStatusDialog.vue?vue&type=template&id=2f9388d6&scoped=true"
import script from "./RecycleStatusDialog.vue?vue&type=script&lang=js"
export * from "./RecycleStatusDialog.vue?vue&type=script&lang=js"

import "./RecycleStatusDialog.vue?vue&type=style&index=0&id=2f9388d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9388d6"]])

export default __exports__